import { api } from '../api.ts';
import { GROUPS, SETTINGS, useBadges, visible, type MenuItem } from '../app/menu.ts';
import { forgetNav, useNav } from '../app/nav.tsx';
import { queryClient, useMe } from '../lib/data.ts';
import { initials, tone } from '../lib/format.ts';
import { openTour } from '../app/tour.tsx';
import { Icon, type IconName } from '../ui/Icon.tsx';

const ROLE: Record<string, string> = { dona: 'Dona', parceira: 'Parceira', recepcao: 'Recepção' };

// Mesmos grupos do menu lateral do computador (app/menu.ts), mais o que só faz sentido no celular.
export function Mais() {
  const nav = useNav();
  const me = useMe().data!;
  const badges = useBadges();
  const row = (key: string, icon: IconName, label: string, onClick: () => void, extra?: React.ReactNode) => (
    <button key={key} className="gl-row gl-btn mais-row" onClick={onClick}><span className="mi"><Icon name={icon} /></span><b>{label}</b>{extra ?? <Icon name="chevR" />}</button>
  );
  const menuRow = (i: MenuItem) => {
    const b = i.badge ? badges[i.badge] : null;
    return row(i.view, i.icon, i.label, () => nav.go(i.view), b ? <em className={'mais-ver' + (b.late ? ' late' : '')}>{b.text}</em> : undefined);
  };
  const grp = (title: string, rows: React.ReactNode[]) => (rows.length ? <><p className="gl-title">{title}</p><div className="gl">{rows}</div></> : null);
  const lean = !!me.salon.settings.leanMenu;
  const extra: Record<string, { before?: React.ReactNode[]; after?: React.ReactNode[] }> = {
    Clientes: {
      before: lean ? [] : [row('retorno', 'users', 'Para chamar de volta', () => nav.open({ kind: 'retorno' }))],
      after: lean ? [] : [row('meuLink', 'cal', 'Link de agendamento', () => nav.go('meuLink'))],
    },
  };
  const settings = visible([SETTINGS], me)[0];
  return (
    <div className="view-enter mais-view">
      <div className="hd"><div className="wordmark-mark" role="img" aria-label="Sublime Nail Design" /></div>
      <div className="heading" style={{ paddingTop: 6 }}><h1>Mais</h1></div>
      <div className="cp2-body">
        <button className="pf-card" onClick={() => nav.go('perfil')}><span className={`av t-${tone(me.user.id)}`}>{initials(me.user.name)}</span>
          <span><b>{me.user.name}</b><small>{ROLE[me.role] ?? me.role} · Meu perfil e aparência</small></span><Icon name="chevR" /></button>
        {GROUPS.map((g) => <div key={g.title} className="mais-grp">{grp(g.title, [...(extra[g.title]?.before ?? []), ...visible(g.items, me).map(menuRow), ...(extra[g.title]?.after ?? [])])}</div>)}
        {settings && <div className="mais-grp">{grp('Salão', [row('setup', 'gear', 'Configurações do salão', () => nav.go('setup'),
          <em className={'mais-ver' + (badges.setup ? ' late' : '')}>{badges.setup ? badges.setup.text : 'horários, serviços, taxas…'}</em>)])}</div>}
        <div className="mais-grp">{grp('Ajuda', [
          row('tour', 'info', 'Tour pelo app', openTour),
          row('instalar', 'home', 'Instalar no celular', () => nav.open({ kind: 'instalar' })),
        ])}</div>
        <div className="mais-grp">{grp('Conta', [
          row('sair', 'logout', 'Sair', async () => { await api.post('/auth/logout').catch(() => undefined); forgetNav(); queryClient.clear(); window.location.reload(); }, <span />),
        ])}</div>
      </div>
      <div style={{ height: 24 }} />
    </div>
  );
}
